<mat-accordion class="rh-headers-align" multi>
  <mat-grid-list cols="1" rowHeight="55px">
    <mat-grid-tile [rowspan]="isExpanded(0) ? 11 : 1">
      <mat-expansion-panel [@.disabled]="true" [style.width]="'98%'" (opened)="onPanelOpen(0)"
        (closed)="onPanelClose(0)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span [style.marginLeft]="'0.5rem'" [style.color]="'var(--sys-primary)'" class="mat-label-large">
              ID Token
            </span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="rh-view-token">
          <mat-form-field [style.width]="'100%'">
            <textarea matInput readonly cols="100" rows="20" [style.resize]="'none'">{{ idToken$ | async }}</textarea>
          </mat-form-field>
          <mat-form-field [style.width]="'100%'">
            <textarea matInput readonly cols="100" rows="20" [style.resize]="'none'">{{ idTokenJson$ | async | json }}</textarea>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </mat-grid-tile>
    <mat-grid-tile [rowspan]="isExpanded(1) ? 9 : 1">
      <mat-expansion-panel [@.disabled]="true" [style.width]="'98%'" (opened)="onPanelOpen(1)"
        (closed)="onPanelClose(1)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span [style.marginLeft]="'0.5rem'" [style.color]="'var(--sys-primary)'" class="mat-label-large">
              Access Token
            </span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="rh-view-token">
          <mat-form-field [style.width]="'100%'">
            <textarea matInput readonly cols="100" rows="14" [style.resize]="'none'">{{ accessToken$ | async }}</textarea>
          </mat-form-field>
          <mat-form-field [style.width]="'100%'">
            <textarea matInput readonly cols="100" rows="14"
              [style.resize]="'none'">{{ accessTokenJson$ | async | json }}</textarea>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </mat-grid-tile>
    <mat-grid-tile [rowspan]="isExpanded(2) ? 7 : 1">
      <mat-expansion-panel [@.disabled]="true" [style.width]="'98%'" (opened)="onPanelOpen(2)"
        (closed)="onPanelClose(2)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span [style.marginLeft]="'0.5rem'" [style.color]="'var(--sys-primary)'" class="mat-label-large">
              Signing Keys
            </span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="rh-view-token">
          <mat-form-field [style.width]="'100%'">
            <textarea matInput readonly cols="100" rows="10" [style.resize]="'none'">{{ signingKeys$ }}</textarea>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </mat-grid-tile>
  </mat-grid-list>
</mat-accordion>